import React from 'react';
import { useSecondScreenData } from '../../../contexts/SecondScreenContext';
import type { WidgetProps } from '../../../types/second-screen.types';

const CurrentPhaseWidget: React.FC<WidgetProps> = () => {
  const { state, theme } = useSecondScreenData();
  const isDark = theme === 'dark';

  if (!state) return null;

  const { phases, currentPhaseIndex } = state;
  const currentPhase = phases[currentPhaseIndex];

  return (
    <div className="flex flex-col h-full px-4 py-3 gap-3">
      {/* Phase name */}
      <div>
        <div className={`text-xs font-medium mb-1 ${isDark ? 'text-primary/70' : 'text-primary'}`}>
          Phase {currentPhaseIndex + 1} of {phases.length}
        </div>
        <h2 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-slate-900'}`}>
          {currentPhase?.name || 'Unknown Phase'}
        </h2>
        {currentPhase?.objectives && (
          <p className={`text-sm mt-1 line-clamp-2 ${isDark ? 'text-white/50' : 'text-slate-500'}`}>
            {currentPhase.objectives}
          </p>
        )}
      </div>

      {/* Phase timeline */}
      <div className="flex items-center gap-1.5 mt-auto">
        {phases.map((phase, index) => (
          <React.Fragment key={phase.id || index}>
            {index > 0 && (
              <div className={`h-[2px] flex-1 min-w-[12px] transition-colors ${
                index <= currentPhaseIndex
                  ? 'bg-primary/50'
                  : isDark ? 'bg-white/10' : 'bg-slate-200'
              }`} />
            )}
            <div className="flex flex-col items-center gap-1">
              <div className="relative">
                {index === currentPhaseIndex && (
                  <div className="absolute inset-0 w-3 h-3 rounded-full bg-primary/30 animate-ping" />
                )}
                <div className={`w-3 h-3 rounded-full transition-colors ${
                  index < currentPhaseIndex
                    ? 'bg-primary'
                    : index === currentPhaseIndex
                    ? 'bg-primary'
                    : isDark ? 'bg-white/20 border border-white/10' : 'bg-slate-200'
                }`} />
              </div>
              <span className={`text-xs font-medium whitespace-nowrap max-w-[60px] truncate ${
                index === currentPhaseIndex
                  ? 'text-primary font-bold'
                  : index < currentPhaseIndex
                  ? isDark ? 'text-white/40' : 'text-slate-400'
                  : isDark ? 'text-white/20' : 'text-slate-300'
              }`}>
                {phase.name}
              </span>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default CurrentPhaseWidget;
